// ---------------------------------------------------------------------------
// pleasantMapStyle — the app's map styles, OFF Mapbox (Morgan, July 24:
// "let's do this now").
//
// Tiles come from OpenFreeMap (openfreemap.org): free, public,
// OpenStreetMap-based vector tiles with NO logo requirement — just the
// "© OpenStreetMap" text credit, which we show. The Pleasant brand pill
// owns the corner.
//
//   • LIGHT  — positron: the pale, calm canvas (closest to the old
//              light-v11 look; Pleasant color tuning happens as a follow-up
//              pass with Morgan's screenshots).
//   • STREETS — bright: richer road detail for active navigation.
//   • DARK   — positron for now; a true Pleasant night style arrives with
//              the CarPlay night-mode round.
//   • SATELLITE — Esri World Imagery (OSM has no satellite photos); Esri's
//              free tier asks for a text credit, included below.
//
// The Mapbox TOKEN is still used for geocoding / traffic ETA API calls —
// those are data requests, not map display, and carry no visual
// attribution requirement.
// ---------------------------------------------------------------------------

export const PLEASANT_LIGHT_STYLE = "https://tiles.openfreemap.org/styles/positron";
export const PLEASANT_STREETS_STYLE = "https://tiles.openfreemap.org/styles/bright";
// True dark for night drives (Carto's free dark basemap — text credit only,
// carried in the attribution control alongside OSM's).
export const PLEASANT_DARK_STYLE =
  "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json";

/** Esri World Imagery as a MapLibre style object (satellite flyover). */
export const SATELLITE_STYLE = {
  version: 8 as const,
  sources: {
    "esri-imagery": {
      type: "raster" as const,
      tiles: [
        "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      ],
      tileSize: 256,
      maxzoom: 19,
      attribution:
        "Powered by Esri — Source: Esri, Maxar, Earthstar Geographics",
    },
  },
  layers: [
    {
      id: "esri-imagery-layer",
      type: "raster" as const,
      source: "esri-imagery",
    },
  ],
};
